import React from "react";
import "./Action.css";

const Action = () => {
  return (
    <section className="action" id="action">
      <div className="action-content">
        <h1>ÁREA DE ATUAÇÃO</h1>

        <div className="action-right">
          <h2>Direito Criminal</h2>
          <h3>
            O Direito Penal é a área que trata das infrações penais e de todas
            as etapas relacionadas à investigação e ao processo criminal. O
            advogado criminalista atua para resguardar os direitos do cliente,
            oferecendo suporte qualificado desde o início da apuração dos fatos.
            A atuação inclui o acompanhamento da investigação, como inquéritos
            policiais, prisões e audiências de custódia, e, no curso do
            processo, a construção de teses, pedidos de liberdade, apresentação
            de peças defensivas, participação em julgamentos e interposição de
            recursos. O compromisso é garantir uma condução técnica, eficiente e
            alinhada ao respeito aos direitos humanos, assegurando a preservação
            das garantias fundamentais em cada etapa da persecução criminal.
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Action;
